"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_shared_js_1 = require("@tableau/api-shared-js");
var WorkbookFormattingEnvUtil = /** @class */ (function () {
    function WorkbookFormattingEnvUtil() {
    }
    WorkbookFormattingEnvUtil.convertToWorkbookFormatting = function (workbookFormattingModel) {
        if (!workbookFormattingModel) {
            return undefined;
        }
        else {
            var formattingMap = workbookFormattingModel.formattingSheets.map(function (currentFormattingSheet) {
                var formattingSheet = {
                    classNameKey: api_shared_js_1.InternalToExternalEnumMappings.classNameKey.convert(currentFormattingSheet.classNameKey),
                    cssProperties: {
                        fontFamily: currentFormattingSheet.cssProperties.fontFamily,
                        fontSize: currentFormattingSheet.cssProperties.fontSize,
                        fontWeight: currentFormattingSheet.cssProperties.fontWeight,
                        fontStyle: currentFormattingSheet.cssProperties.fontStyle,
                        textDecoration: currentFormattingSheet.cssProperties.textDecoration,
                        color: currentFormattingSheet.cssProperties.color,
                    },
                };
                return formattingSheet;
            });
            var result = {
                formattingSheets: formattingMap,
            };
            return result;
        }
    };
    return WorkbookFormattingEnvUtil;
}());
exports.WorkbookFormattingEnvUtil = WorkbookFormattingEnvUtil;
//# sourceMappingURL=WorkbookFormattingEnvUtil.js.map